/**
 * Green Flag — EventCardSkeleton
 *
 * Loading placeholder for {@link EventCard}. Reuses the `eventCard` slot recipe
 * so spacing/dimensions match the real card exactly, and fills the slots with
 * Chakra Skeletons. Non-interactive (no onClick/role).
 */

import { Box, Skeleton, chakra, useSlotRecipe } from "@chakra-ui/react";

export function EventCardSkeleton() {
  const recipe = useSlotRecipe({ key: "eventCard" });
  const styles = recipe({});

  return (
    <chakra.div css={styles.root} cursor="default">
      <Skeleton w="116px" h="116px" flex="0 0 116px" borderRadius="xs" />
      <Box css={styles.body}>
        <Skeleton h="3" w="40%" borderRadius="xs" />
        <Skeleton h="5" w="80%" borderRadius="xs" />
        <Skeleton h="4" w="55%" borderRadius="xs" />
      </Box>
    </chakra.div>
  );
}
